export interface ResetPasswordResponse {
  token: string;
  refreshToken: string;
  userId: string;
  email: string;
}

export enum ResetPasswordResponseStatusCodes {
  BadRequest = 400,
  Invalid = 403,
}
